import { render, staticRenderFns } from "./InputGroupPrepend.vue?vue&type=template&id=65ec017d&"
import script from "./InputGroupPrepend.vue?vue&type=script&lang=js&"
export * from "./InputGroupPrepend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports